import { routerPostCall } from '../../axios';

const addTrustedDevice = (state, params) => {
  const url = `/auth/addAuthTrustedDevice`;
  return routerPostCall(state, url, params);
};
export default { addTrustedDevice };
